import { Component, Input } from '@angular/core';
import { Certification } from 'src/app/core/models/certification.model';

@Component({
  selector: 'app-cert-summary-list',
  templateUrl: './cert-summary-list.component.html',
  styleUrls: ['./cert-summary-list.component.scss']
})
export class CertSummaryListComponent {
  @Input() certificates: Certification[] = [];
  @Input() isLoading = false;

  get activeCerts(): Certification[] {
    return this.certificates.filter(c => c.valid);
  }

  get historyCerts(): Certification[] {
    return this.certificates.filter(c => !c.valid);
  }
}
